/**
 * Labstep
 *
 * @module core/Select/Search/Modal
 * @desc An search select component in modal
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { FormShowEditSearchSelectToggleViewComponent } from 'labstep-web/core/Form/ShowEdit/SearchSelect/Toggle';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import React from 'react';
import type { ISearchSelectModalViewComponentProps } from './types';

export const SearchSelectModalViewComponent: RFC<
  ISearchSelectModalViewComponentProps
> = ({
  actionComponentProps: customActionComponentProps,
  entityName,
  canEdit,
  status,
  children,
  hasValue,
  onChange,
  toggleModal,
  dataCy,
}) => {
  if (hasValue) {
    if (canEdit) {
      return (
        <FormShowEditSearchSelectToggleViewComponent
          status={status}
          onExpand={(): void => onChange(null)}
          children={children}
        />
      );
    }
    return <>{children}</>;
  }
  return (
    <ActionComponent
      dataCy={dataCy}
      dataTestId="select-search-modal-action"
      disabled={!canEdit}
      status={status}
      onClick={toggleModal}
      {...(customActionComponentProps || {
        type: 'text',
        text: `${
          canEdit ? 'Specify' : 'No'
        } ${getHumanReadableEntityName(entityName)}`,
        elementProps: {
          showEdit: true,
        },
      })}
    />
  );
};
